import { AppDispatch } from 'core/types';
import { useDispatch } from 'react-redux';
import { createGuardingRequest } from 'core/guardingRequestForm/guardingRequestFormApi';
import { useEffect, useRef, useState } from 'react';
import { unwrapResult } from '@reduxjs/toolkit';
import { VisitRequestFormResponsePayload } from 'core/guardingRequestForm/types';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { notification } from 'antd';

const CreateNewGuardingRequest = () => {
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [requestMade, setRequestMade] = useState(false);
    const requestSentRef = useRef(false);

    const siteId = searchParams.get('siteId');

    const sendRequest = async () => {
        if (!siteId) {
            notification.error({
                message: 'Site Not Selected',
                description: 'Please select a site before creating a guarding request.',
            });
            navigate('/sites', { replace: true });
            return;
        }

        if (!requestMade && !requestSentRef.current) {
            requestSentRef.current = true;
            try {
                await dispatch(createGuardingRequest({ siteId: Number(siteId) }))
                    .then(unwrapResult)
                    .then((payload: VisitRequestFormResponsePayload) => {
                        // Retail guarding starts on Date (step 2); Job Details moves after Visitors.
                        const firstStep = payload.stepData?.isRetail ? 2 : 1;
                        navigate(`/guarding-request/${payload.visitRequest.id}/step/${firstStep}`);
                    });
                window.location.reload();
            } catch (error) {
                console.error('Failed to create a guarding request: ', error);
            } finally {
                setRequestMade(true);
            }
        }
    };

    useEffect(() => {
        sendRequest();
    }, [requestMade]);
    return null;
};

export default CreateNewGuardingRequest;
